import { useEffect, useState } from 'react'

import { useCheckCameraPermission } from '@core/devicePermissions/useCheckCameraPermission'

/**
 * A hook that checks the camera permission status on a regular interval.
 */
export const useCameraPermission = () => {
  const { checkPermissionStatus } = useCheckCameraPermission({})

  const [permission, setPermission] = useState<PermissionState | 'unknown'>(
    'unknown',
  )

  useEffect(() => {
    async function checkPermission() {
      const permission = await checkPermissionStatus()
      setPermission(permission)
    }

    const interval = setInterval(() => {
      checkPermission()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [checkPermissionStatus])

  return permission
}
